var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFleetMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_598_1",
    "data-name": "Component 598 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10704",
    "data-name": "Rectangle 10704",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13324",
    "data-name": "Group 13324",
    transform: "translate(-4210 -1125.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13323",
    "data-name": "Group 13323",
    transform: "translate(4211 1129.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delivery_2_",
    "data-name": "delivery (2)",
    transform: "translate(0 2.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13303",
    "data-name": "Group 13303",
    transform: "translate(11.787 8.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13302",
    "data-name": "Group 13302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10741",
    "data-name": "Path 10741",
    d: "M324.512,304.4a2.361,2.361,0,1,0,2.361,2.361A2.364,2.364,0,0,0,324.512,304.4Zm0,3.542a1.181,1.181,0,1,1,1.181-1.181A1.182,1.182,0,0,1,324.512,307.945Z",
    transform: "translate(-322.151 -304.403)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13305",
    "data-name": "Group 13305",
    transform: "translate(3.719 8.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13304",
    "data-name": "Group 13304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10742",
    "data-name": "Path 10742",
    d: "M104.008,304.4a2.361,2.361,0,1,0,2.361,2.361A2.364,2.364,0,0,0,104.008,304.4Zm0,3.542a1.181,1.181,0,1,1,1.181-1.181A1.182,1.182,0,0,1,104.008,307.945Z",
    transform: "translate(-101.647 -304.403)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13307",
    "data-name": "Group 13307",
    transform: "translate(12.102 1.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13306",
    "data-name": "Group 13306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10743",
    "data-name": "Path 10743",
    d: "M334.393,111.115a.591.591,0,0,0-.528-.325h-3.109v1.181H333.5l1.608,3.2,1.055-.531Z",
    transform: "translate(-330.756 -110.79)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13309",
    "data-name": "Group 13309",
    transform: "translate(7.911 10.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13308",
    "data-name": "Group 13308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10701",
    "data-name": "Rectangle 10701",
    width: 4.467,
    height: 1.181,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13311",
    "data-name": "Group 13311",
    transform: "translate(1.673 10.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13310",
    "data-name": "Group 13310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10744",
    "data-name": "Path 10744",
    d: "M48.352,353.345H46.305a.59.59,0,1,0,0,1.181h2.047a.59.59,0,1,0,0-1.181Z",
    transform: "translate(-45.715 -353.345)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13313",
    "data-name": "Group 13313",
    transform: "translate(1.673 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13312",
    "data-name": "Group 13312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10745",
    "data-name": "Path 10745",
    d: "M62.652,84.968l-1.161-1.5a.59.59,0,0,0-.466-.228h-4.29V79.111a.59.59,0,0,0-.59-.59H46.305a.59.59,0,0,0,0,1.181h9.249v4.132a.59.59,0,0,0,.59.59h4.591l.86,1.107v3.045H59.962a.59.59,0,0,0,0,1.181h2.224a.59.59,0,0,0,.59-.59V85.33A.591.591,0,0,0,62.652,84.968Z",
    transform: "translate(-45.715 -78.521)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13315",
    "data-name": "Group 13315",
    transform: "translate(0.964 7.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13314",
    "data-name": "Group 13314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10746",
    "data-name": "Path 10746",
    d: "M29.659,271.6H26.943a.59.59,0,1,0,0,1.181h2.716a.59.59,0,0,0,0-1.181Z",
    transform: "translate(-26.353 -271.597)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13317",
    "data-name": "Group 13317",
    transform: "translate(0 4.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13316",
    "data-name": "Group 13316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10747",
    "data-name": "Path 10747",
    d: "M5.628,208.134H.59a.59.59,0,0,0,0,1.181H5.628a.59.59,0,0,0,0-1.181Z",
    transform: "translate(0 -208.134)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13319",
    "data-name": "Group 13319",
    transform: "translate(0.964 2.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13318",
    "data-name": "Group 13318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10748",
    "data-name": "Path 10748",
    d: "M31.981,144.672H26.943a.59.59,0,1,0,0,1.181h5.038a.59.59,0,1,0,0-1.181Z",
    transform: "translate(-26.353 -144.672)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13322",
    "data-name": "Group 13322",
    transform: "translate(11.67 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M9.662,11.236h-1.2v-1.18h.611V7.011L8.214,5.906l0-.024L7.54,4.723h.014L6.366,2.361H4.211v0l-1.18,0V1.181H.59A.591.591,0,0,1,.59,0H3.621a.591.591,0,0,1,.59.59v.59H6.73a.588.588,0,0,1,.527.325L9.029,5.028l1.1,1.418a.6.6,0,0,1,.124.362v3.837A.591.591,0,0,1,9.662,11.236Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13321",
    "data-name": "Group 13321",
    transform: "translate(7.324 10.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13314-2",
    "data-name": "Group 13314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10746-2",
    "data-name": "Path 10746",
    d: "M32.288,271.6h-.973a.59.59,0,1,0,0,1.181h.973a.59.59,0,0,0,0-1.181Z",
    transform: "translate(-30.725 -271.597)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetMenu);
export default __webpack_public_path__ + "static/media/fleet-menu.aac591d6cd9f06b5971b7ec738ed6873.svg";
export { ForwardRef as ReactComponent };